module.exports = __webpack_public_path__ + "static/media/ic_notice_announce.7c6b79cf.png";